import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CampaignIcon from '@mui/icons-material/Campaign';
import { useAuth } from "../context/AuthContext";

const SidebarDashboard = ({ open, onClose, onOptionClick }) => {
  const { user } = useAuth(); 

  const studentOptions = [
    { label: "Perfil", icon: <AccountCircleIcon />, value: "/Profile" },
    { label: "Cursos disponibles", icon: <SchoolIcon />, value: "/AvailableCourses" },
  ];

  const adminOptions = [
    { label: "Perfil", icon: <AccountCircleIcon />, value: "/Profile" },
    { label: "Gestión de Usuarios", icon: <PeopleIcon />, value: "/ManageUsers" },
    { label: "Cursos", icon: <SchoolIcon />, value: "/Course" },
    { label: "Evidencias", icon: <FactCheckIcon />, value: "/Evidencias" },
    { label: "Noticias y eventos", icon: <CampaignIcon />, value: "/NoticiasEventos" },
  ];

  const options = user?.idRol === "2" ? adminOptions : studentOptions;

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box
        width={250}
        bgcolor="white"
        height="100%"
        role="presentation"
        onClick={onClose}
        onKeyDown={onClose}
        >
        <List>
          {options.map((option) => (
            <ListItem button key={option.value} onClick={() => onOptionClick(option.value)}>
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.label} />
            </ListItem>
          ))}
        </List>
        <Divider />
      </Box>
    </Drawer>
  );
};

export default SidebarDashboard;
